import gql from "graphql-tag";

export default gql`
  mutation deleteTenantTask($id: String!) {
    deleteTenantTask(id: $id) {
      __typename
      id
      task
      property
      category
      reference_doc
      reference_doc_section
      required_docs
      effective_period
      due_dates
      due_dates_rrule
      contact_email
      notify_email
      user
      archived
    }
  }
`;
